import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddScansApi, AdminHelperApi, UpdatePlanApi, EnableCheckinProApi, addAiCreditApi } from "../../apis/AdminApis/AdminHelperApis";
import { showSnackbar } from "../../slices/SnackbarSlice";
import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";

export const GetAdminHelpersAction = createAsyncThunk(
    "adminHelper/fetchAdminData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await AdminHelperApi()
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const updateAddonPlanAction = createAsyncThunk(
    "adminHelper/updateplan",
    async (payload: any, { rejectWithValue, dispatch }) => {
        try {
            const response = await UpdatePlanApi(payload)
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const AddScansAction = createAsyncThunk(
    "adminHelper/addscans",
    async (payload: any, { rejectWithValue, dispatch }) => {
        try {
            const response = await AddScansApi(payload)
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const AddCreditAction = createAsyncThunk(
    "adminHelper/addCredit",
    async (payload: { userId: string; credits: number }, { rejectWithValue, dispatch }) => {
        try {
            const response = await AxiosInstance.post(apiRoutes.addcredit, payload);
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message || error.message, type: "error" }));
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);

export const addAiCreditAction = createAsyncThunk(
    "adminHelper/addAiCredit",
    async ({ business_id, credits }: { business_id: string; credits: number }, { rejectWithValue, dispatch }) => {
        try {
            const response = await addAiCreditApi(business_id, credits)
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message || error.message, type: "error" }));
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);

export const EnableCheckinProAction = createAsyncThunk(
    "adminHelper/enablecheckinpro",
    async (payload: any, { rejectWithValue, dispatch }) => {
        try {
            const response = await EnableCheckinProApi(payload)
            dispatch(showSnackbar({ message: response?.data?.message, type: "success" }));
            return response.data;
        } catch (error: any) {
            dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);
